import { alertTypeLabel } from "@/lib/alert-type-label";

import { AlertType } from "@/types/enums/alert-type";
import { ProviderNotificationSummary } from "@/types/notification";

/** Headlines for a stack of one alert type, by type: what the stack adds up to. */
const STACK_SUMMARY: Partial<Record<AlertType, (count: number) => string>> = {
  [AlertType.PAYMENT_FAILED]: (n) => `${n} payments failed`,
  [AlertType.PLANNED_PAYMENT_FAILED]: (n) => `${n} scheduled payments failed`,
  [AlertType.MEMBERSHIP_DELINQUENT]: (n) => `${n} memberships went delinquent`,
  [AlertType.FORM_SUBMITTED]: (n) => `${n} forms submitted`,
  [AlertType.MESSAGE_FAILED]: (n) => `${n} messages failed to send`,
  [AlertType.SELF_SCHEDULED_APPOINTMENT]: (n) =>
    `${n} appointments booked online`,
  [AlertType.SELF_SCHEDULED_APPOINTMENT_CANCELLED]: (n) =>
    `${n} online bookings cancelled`,
  [AlertType.SELF_SCHEDULED_APPOINTMENT_UPDATED]: (n) =>
    `${n} online bookings changed`,
};

/**
 * True for a row standing for several alerts of one type (not one conversation).
 * Such a row reads as one summary rather than as its newest alert.
 */
export function isTypeStack(
  notification: ProviderNotificationSummary,
): boolean {
  return (
    (notification.messageCount ?? 1) > 1 &&
    !!notification.groupKey?.startsWith("type:")
  );
}

/** "15 payments failed" — the headline of a type stack. */
export function stackSummary(
  notification: ProviderNotificationSummary,
): string {
  const count = notification.messageCount ?? 1;
  const summarize = STACK_SUMMARY[notification.alert.type];
  return summarize
    ? summarize(count)
    : `${count} ${alertTypeLabel(notification.alert.type)} alerts`;
}
